import { ArrowLeftIcon, ArrowTopRightIcon, MagnifyingGlassIcon } from '@radix-ui/react-icons';
import { Card } from '@radix-ui/themes';
import { Link } from 'react-router-dom';
import { scorePath } from '../api';
import ScoreSearchForm from './ScoreSearchForm';
import './ScoreResearcher.css';

export default function ScoreResearcher() {
  return (
    <div className="lookup-page">
      <Link to="/" className="back-link"><ArrowLeftIcon /> Back to the score grid</Link>
      <div className="lookup-layout">
        <section className="lookup-intro">
          <p className="eyebrow"><MagnifyingGlassIcon /> The score researcher</p>
          <h1 className="display-title">Score<br /><em>lookup.</em></h1>
          <p className="hero-copy">Pick a final score and see every matchup in the archive that finished with it. Add a team to narrow the search.</p>
        </section>
        <ScoreSearchForm />
      </div>
      <section className="archive-picks" aria-labelledby="picks-title">
        <p className="eyebrow">A few scores to explore</p>
        <h2 className="section-title" id="picks-title">From the archive</h2>
        <div className="pick-grid">
          <Card asChild className="pick-card"><Link to={scorePath(31, 28)}><span>31–28</span><span>Decided by a field goal <ArrowTopRightIcon /></span></Link></Card>
          <Card asChild className="pick-card"><Link to={scorePath(0, 0)}><span>0–0</span><span>Scoreless ties <ArrowTopRightIcon /></span></Link></Card>
          <Card asChild className="pick-card"><Link to={scorePath(222, 0)}><span>222–0</span><span>Beyond the grid <ArrowTopRightIcon /></span></Link></Card>
        </div>
      </section>
    </div>
  );
}
